import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Overlay from "../molecules/overlay";
import BoutonIcon from "./boutonIcon";
import PlayIcon from "../icons/play";

const Musique = ({musique}) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);

    const openOverlay = () => {
        setIsOverlayOpen(true);
    }

    return (
        <>
            <div className="relative flex items-center justify-between bg-[#1A1A1A] bg-opacity-70 px-6 py-4 rounded-lg hover:bg-[#222222] hover:bg-opacity-90 hover:shadow-lg transition-all duration-300 cursor-pointer flex-shrink" onClick={openOverlay}>
                <div className="flex items-center gap-6">
                    <h1 className="text-white font-semibold text-lg font-poppins">{musique.annee}</h1>
                    <div className="flex flex-col text-left px-4 border-l border-gray-600">
                        <h1 className="text-white font-semibold text-lg font-poppins">{musique.titre}</h1>
                        <h2 className="text-gray-400 text-xs font-poppins">{musique.interprete}</h2>
                    </div>
                </div>
                <BoutonIcon
                    icon={<PlayIcon/>}
                    onClick={openOverlay}
                    width={8}
                    height={8}/>
            </div>


            {isOverlayOpen && (
                <Overlay onClose={() => setIsOverlayOpen(false)}>
                    <iframe
                        src={`${musique.video}?autoplay=1`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="w-[90vw] h-[90vh] max-w-[1600px] max-h-[900px] rounded-md"
                    />
                </Overlay>
            )}
        </>
    )
}

Musique.propTypes = {
    musique: PropTypes.shape({
        annee: PropTypes.string.isRequired,
        titre: PropTypes.string.isRequired,
        interprete: PropTypes.string.isRequired,
        video: PropTypes.string.isRequired,
        lien: PropTypes.string,
    }).isRequired,
}

export default Musique;